<template>
    <v-app-bar color="primary">
    <v-toolbar-title text="RSE Metrics" class="pl-5"/>
    <template v-slot:append>
      <v-btn class="text-none mr-5" @click="handleLogout" :text="t('drawer.logout')" size="large"/>
    </template>
  </v-app-bar>
</template>


<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useGeneralStore } from "@/stores/general";
import { useSessionStore } from "@/stores/session";

const { t } = useI18n();
const sessionStore = useSessionStore();
const generalStore = useGeneralStore();

const items = [
  { title: "Providers", value: "home", to: "/home/" },
];

const handleLogout = () => {
  sessionStore.logout();
  generalStore.resetStores();
};
</script>
